import cn from 'classnames';

import { CloseButton } from '../../../../components/closeButton/CloseButton';

import styles from '../FrontPageModal.module.css';

interface FrontPageModalHeaderProps {
    title?: string;
    titleId?: string;
    onClose: (open: boolean) => void;
}

export const FrontPageModalHeader = ({ title, titleId, onClose }: FrontPageModalHeaderProps) => (
    <header className={cn(styles.modal__header)}>
        {title && (
            <h1 id={titleId} className={styles.modal__header__title}>
                {title}
            </h1>
        )}
        <CloseButton onClose={onClose} />
    </header>
);
